import React from "react";
import { cn } from "@/designs/shadcn/lib/utils";

type BoxRadius = "sm" | "md" | "lg"; // sm=16, md=18, lg=24

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  radius?: BoxRadius;
}

/**
 * Box is a simple container with the standard rounded, padded, light-gray background
 * used to wrap grouped content like lists.
 *
 * Defaults: radius=lg (24px), padding=px-6 py-7
 */
export default function Box({
  children,
  className,
  radius = "lg",
  ...props
}: BoxProps) {
  const radiusClass =
    radius === "sm"
      ? "rounded-[16px]"
      : radius === "md"
        ? "rounded-[18px]"
        : "rounded-[24px]";

  return (
    <div
      className={cn("bg-[#F4F6F9] px-6 py-7", radiusClass, className)}
      {...props}
    >
      {children}
    </div>
  );
}
